import { render, staticRenderFns } from "./citiesSubClassifierView.vue?vue&type=template&id=5cd6cc40&scoped=true&"
import script from "./citiesSubClassifierView.vue?vue&type=script&lang=js&"
export * from "./citiesSubClassifierView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6cc40",
  null
  
)

export default component.exports